export default __webpack_public_path__ + "static/media/external-link.4ae5039d.svg";